exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.headerDiv[data-v-589d3bd5] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  margin-bottom: 3px;\n}\n/* #custom-disabled.v-btn--disabled{\n  background-color: #ececec !important;\n} */\n", ""]);

// exports
